import React from 'react';
import { Col, Image, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { TaskNameMapper } from '../../../hooks/types/response';
import { Body, CardContainer, Header } from '../styles';

const PULL_SUSTAINED_FORCE_ICON =
	'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/result-pull-sustained-force.svg';
const PUSH_SUSTAINED_FORCE_ICON =
	'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/result-push-sustained-force.svg';

interface SustainedForceCardProps {
	task_name: TaskNameMapper.Pull | TaskNameMapper.Push;
}

export const SustainedForceCard: React.FC<SustainedForceCardProps> = ({ task_name }) => {
	const {
		libertyMutualResult: { summary }
	} = useLibertyMutualSubStepsContext();

	const sustainedForceSVGMapper = {
		[TaskNameMapper.Pull]: PULL_SUSTAINED_FORCE_ICON,
		[TaskNameMapper.Push]: PUSH_SUSTAINED_FORCE_ICON
	};

	return (
		<CardContainer>
			<Header>{I18n.get('Sustained force')}</Header>
			<Body>
				<Row justify="center" style={{ padding: '1rem 0 0 0' }}>
					<Col>
						<Row justify="space-between">
							<Col xs={24}>
								<Image
									preview={false}
									draggable={false}
									alt={I18n.get(`Sustained force: ${summary.sustained_force}`)}
									src={sustainedForceSVGMapper[task_name]}
									width="100px"
								/>
							</Col>
							<Col xs={24} style={{ padding: '0.75rem 0', fontSize: '1.1rem' }}>
								{I18n.get(summary.sustained_force)}
							</Col>
						</Row>
					</Col>
				</Row>
			</Body>
		</CardContainer>
	);
};
